module.exports = __webpack_public_path__ + "static/media/14-Chelsea.e500da6e.mp4";